/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ApiError,
    ApiErrorFromJSON,
    ApiErrorToJSON,
    ClaimOverwolfRewardResponse,
    ClaimOverwolfRewardResponseFromJSON,
    ClaimOverwolfRewardResponseToJSON,
    CreateOWUserEventBody,
    CreateOWUserEventBodyFromJSON,
    CreateOWUserEventBodyToJSON,
    CreateOverwolfGameBody,
    CreateOverwolfGameBodyFromJSON,
    CreateOverwolfGameBodyToJSON,
    CreateOverwolfGameImages,
    CreateOverwolfGameImagesFromJSON,
    CreateOverwolfGameImagesToJSON,
    FormError,
    FormErrorFromJSON,
    FormErrorToJSON,
    GetGameEventDataResponse,
    GetGameEventDataResponseFromJSON,
    GetGameEventDataResponseToJSON,
    GetGameEventDataSort,
    GetGameEventDataSortFromJSON,
    GetGameEventDataSortToJSON,
    GetOverwolfEventMappingsResponse,
    GetOverwolfEventMappingsResponseFromJSON,
    GetOverwolfEventMappingsResponseToJSON,
    GetOverwolfEventTypesResponse,
    GetOverwolfEventTypesResponseFromJSON,
    GetOverwolfEventTypesResponseToJSON,
    GetOverwolfEventTypesSort,
    GetOverwolfEventTypesSortFromJSON,
    GetOverwolfEventTypesSortToJSON,
    GetOverwolfGamesResponse,
    GetOverwolfGamesResponseFromJSON,
    GetOverwolfGamesResponseToJSON,
    GetOverwolfQuestsResponse,
    GetOverwolfQuestsResponseFromJSON,
    GetOverwolfQuestsResponseToJSON,
    GetOverwolfQuestsSort,
    GetOverwolfQuestsSortFromJSON,
    GetOverwolfQuestsSortToJSON,
    GetOverwolfXPResponse,
    GetOverwolfXPResponseFromJSON,
    GetOverwolfXPResponseToJSON,
    GetUserStatsResponse,
    GetUserStatsResponseFromJSON,
    GetUserStatsResponseToJSON,
    GetUserSummaryResponse,
    GetUserSummaryResponseFromJSON,
    GetUserSummaryResponseToJSON,
    InlineObject14,
    InlineObject14FromJSON,
    InlineObject14ToJSON,
    InlineResponse20020,
    InlineResponse20020FromJSON,
    InlineResponse20020ToJSON,
    InlineResponse20021,
    InlineResponse20021FromJSON,
    InlineResponse20021ToJSON,
    InlineResponse20022,
    InlineResponse20022FromJSON,
    InlineResponse20022ToJSON,
    OWEventType,
    OWEventTypeFromJSON,
    OWEventTypeToJSON,
    OWEventTypeBody,
    OWEventTypeBodyFromJSON,
    OWEventTypeBodyToJSON,
    OWEventTypeResponse,
    OWEventTypeResponseFromJSON,
    OWEventTypeResponseToJSON,
    OWGame,
    OWGameFromJSON,
    OWGameToJSON,
    OWGameResponse,
    OWGameResponseFromJSON,
    OWGameResponseToJSON,
    OWQuestBody,
    OWQuestBodyFromJSON,
    OWQuestBodyToJSON,
    OWQuestResponse,
    OWQuestResponseFromJSON,
    OWQuestResponseToJSON,
    OWReward,
    OWRewardFromJSON,
    OWRewardToJSON,
    SortOrder,
    SortOrderFromJSON,
    SortOrderToJSON,
} from '../models';

export interface ClaimOverwolfRewardRequest {
    rewardId: string;
    rewardConfigId?: string;
    gameId?: string;
}

export interface CreateOverwolfEventTypeRequest {
    oWEventTypeBody?: OWEventTypeBody;
}

export interface CreateOverwolfGameRequest {
    createOverwolfGameBody?: CreateOverwolfGameBody;
}

export interface CreateOverwolfQuestRequest {
    oWQuestBody?: OWQuestBody;
}

export interface GetEnhancedGameInfoRequest {
    id: string;
}

export interface GetGameBySlugRequest {
    slug: string;
}

export interface GetGameEventDataRequest {
    gameId?: string;
    userId?: string;
    eventName?: string;
    fieldName?: string;
    fieldValue?: string;
    regex?: string;
    dateStart?: string;
    dateEnd?: string;
    sort?: GetGameEventDataSort;
    order?: SortOrder;
    limit?: number;
    offset?: number;
    numberOfAvailableOffsets?: number;
}

export interface GetOverwolfAvailableEventTypesRequest {
    id: string;
}

export interface GetOverwolfEventTypeRequest {
    id: string;
}

export interface GetOverwolfEventTypesRequest {
    search?: string;
    game?: string;
    sort?: GetOverwolfEventTypesSort;
    order?: SortOrder;
    limit?: number;
    offset?: number;
    numberOfAvailableOffsets?: number;
}

export interface GetOverwolfGameRequest {
    id: string;
}

export interface GetOverwolfGameRewardsRequest {
    id: string;
}

export interface GetOverwolfGamesRequest {
    search?: string;
    seoFilter?: GetOverwolfGamesSeoFilterEnum;
    eventFilter?: GetOverwolfGamesEventFilterEnum;
    steamFilter?: GetOverwolfGamesSteamFilterEnum;
    limit?: number;
    offset?: number;
    numberOfAvailableOffsets?: number;
}

export interface GetOverwolfQuestsRequest {
    game?: string;
    isActive?: string;
    search?: string;
    sort?: GetOverwolfQuestsSort;
    order?: SortOrder;
    limit?: number;
    offset?: number;
    numberOfAvailableOffsets?: number;
}

export interface GetOverwolfUserStatsRequest {
    gameId?: string;
    rewardId?: string;
    rewardCategory?: GetOverwolfUserStatsRewardCategoryEnum;
}

export interface GetOverwolfXpRequest {
    subject: GetOverwolfXpSubjectEnum;
    overwolfRewardId?: string;
    gameId?: string;
    notes?: string;
}

export interface LogOWUserEventRequest {
    createOWUserEventBody?: CreateOWUserEventBody;
}

export interface RemoveOverwolfEventTypeRequest {
    id: string;
}

export interface RemoveOverwolfQuestRequest {
    id: string;
}

export interface SearchEnhancedGamesRequest {
    search?: string;
    seoEnabled?: boolean;
    timeTrackedGame?: boolean;
    hasEvents?: boolean;
    limit?: number;
    offset?: number;
}

export interface UpdateEnhancedGameInfoRequest {
    inlineObject14: InlineObject14;
}

export interface UpdateOverwolfEventTypeRequest {
    id: string;
    oWEventTypeBody?: OWEventTypeBody;
}

export interface UpdateOverwolfGameRequest {
    id: string;
    createOverwolfGameBody?: CreateOverwolfGameBody;
}

export interface UpdateOverwolfGameImagesRequest {
    id: string;
    createOverwolfGameImages?: CreateOverwolfGameImages;
}

export interface UpdateOverwolfQuestRequest {
    id: string;
    oWQuestBody?: OWQuestBody;
}

/**
 * OverwolfApi - interface
 * @export
 * @interface OverwolfApiInterface
 */
export interface OverwolfApiInterface {
    /**
     * Claims an Overwolf completed reward.
     * @param {string} rewardId 
     * @param {string} [rewardConfigId] 
     * @param {string} [gameId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverwolfApiInterface
     */
    claimOverwolfRewardRaw(requestParameters: ClaimOverwolfRewardRequest): Promise<runtime.ApiResponse<ClaimOverwolfRewardResponse>>;

    /**
     * Claims an Overwolf completed reward.
     */
    claimOverwolfReward(requestParameters: ClaimOverwolfRewardRequest): Promise<ClaimOverwolfRewardResponse>;

    /**
     * Used to create new Overwolf event type
     * @param {OWEventTypeBody} [oWEventTypeBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverwolfApiInterface
     */
    createOverwolfEventTypeRaw(requestParameters: CreateOverwolfEventTypeRequest): Promise<runtime.ApiResponse<OWEventTypeResponse>>;

    /**
     * Used to create new Overwolf event type
     */
    createOverwolfEventType(requestParameters: CreateOverwolfEventTypeRequest): Promise<OWEventTypeResponse>;

    /**
     * Used to create new Overwolf game
     * @param {CreateOverwolfGameBody} [createOverwolfGameBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverwolfApiInterface
     */
    createOverwolfGameRaw(requestParameters: CreateOverwolfGameRequest): Promise<runtime.ApiResponse<OWGame>>;

    /**
     * Used to create new Overwolf game
     */
    createOverwolfGame(requestParameters: CreateOverwolfGameRequest): Promise<OWGame>;

    /**
     * Used to create new Overwolf quest (OWReward doc)
     * @param {OWQuestBody} [oWQuestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverwolfApiInterface
     */
    createOverwolfQuestRaw(requestParameters: CreateOverwolfQuestRequest): Promise<runtime.ApiResponse<OWQuestResponse>>;

    /**
     * Used to create new Overwolf quest (OWReward doc)
     */
    createOverwolfQuest(requestParameters: CreateOverwolfQuestRequest): Promise<OWQuestResponse>;

    /**
     * Dismiss the weekly limit feedback for the user\'s Overwolf reward stats.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverwolfApiInterface
     */
    dismissWeeklyLimitFeedbackRaw(): Promise<runtime.ApiResponse<void>>;

    /**
     * Dismiss the weekly limit feedback for the user\'s Overwolf reward stats.
     */
    dismissWeeklyLimitFeedback(): Promise<void>;

    /**
     * Get list of all event types without pagination
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverwolfApiInterface
     */
    getAllOverwolfEventTypesRaw(): Promise<runtime.ApiResponse<InlineResponse20021>>;

    /**
     * Get list of all event types without pagination
     */
    getAllOverwolfEventTypes(): Promise<InlineResponse20021>;

    /**
     * Get enhanced game information including all original and Steam fields for Admin and front-end display
     * @param {string} id The Overwolf game ID or MongoDB ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverwolfApiInterface
     */
    getEnhancedGameInfoRaw(requestParameters: GetEnhancedGameInfoRequest): Promise<runtime.ApiResponse<InlineResponse20020>>;

    /**
     * Get enhanced game information including all original and Steam fields for Admin and front-end display
     */
    getEnhancedGameInfo(requestParameters: GetEnhancedGameInfoRequest): Promise<InlineResponse20020>;

    /**
     * Get game information by URL slug for public game pages
     * @param {string} slug The URL slug of the game
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverwolfApiInterface
     */
    getGameBySlugRaw(requestParameters: GetGameBySlugRequest): Promise<runtime.ApiResponse<OWGameResponse>>;

    /**
     * Get game information by URL slug for public game pages
     */
    getGameBySlug(requestParameters: GetGameBySlugRequest): Promise<OWGameResponse>;

    /**
     * Get list of all event dumps
     * @param {string} [gameId] 
     * @param {string} [userId] 
     * @param {string} [eventName] 
     * @param {string} [fieldName] 
     * @param {string} [fieldValue] 
     * @param {string} [regex] 
     * @param {string} [dateStart] 
     * @param {string} [dateEnd] 
     * @param {GetGameEventDataSort} [sort] 
     * @param {SortOrder} [order] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {number} [numberOfAvailableOffsets] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverwolfApiInterface
     */
    getGameEventDataRaw(requestParameters: GetGameEventDataRequest): Promise<runtime.ApiResponse<GetGameEventDataResponse>>;

    /**
     * Get list of all event dumps
     */
    getGameEventData(requestParameters: GetGameEventDataRequest): Promise<GetGameEventDataResponse>;

    /**
     * Fetch available event types for a specific game
     * @param {string} id The ID of the game to retrieve available event types for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverwolfApiInterface
     */
    getOverwolfAvailableEventTypesRaw(requestParameters: GetOverwolfAvailableEventTypesRequest): Promise<runtime.ApiResponse<Array<OWEventTypeResponse>>>;

    /**
     * Fetch available event types for a specific game
     */
    getOverwolfAvailableEventTypes(requestParameters: GetOverwolfAvailableEventTypesRequest): Promise<Array<OWEventTypeResponse>>;

    /**
     * Get list of all dual games
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverwolfApiInterface
     */
    getOverwolfDualGamesRaw(): Promise<runtime.ApiResponse<Array<OWGame>>>;

    /**
     * Get list of all dual games
     */
    getOverwolfDualGames(): Promise<Array<OWGame>>;

    /**
     * Get list of all game event mappings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverwolfApiInterface
     */
    getOverwolfEventMappingsRaw(): Promise<runtime.ApiResponse<GetOverwolfEventMappingsResponse>>;

    /**
     * Get list of all game event mappings
     */
    getOverwolfEventMappings(): Promise<GetOverwolfEventMappingsResponse>;

    /**
     * Get a single event type by ID
     * @param {string} id The ID of the event type to retrieve
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverwolfApiInterface
     */
    getOverwolfEventTypeRaw(requestParameters: GetOverwolfEventTypeRequest): Promise<runtime.ApiResponse<OWEventType>>;

    /**
     * Get a single event type by ID
     */
    getOverwolfEventType(requestParameters: GetOverwolfEventTypeRequest): Promise<OWEventType>;

    /**
     * Get list of all event types
     * @param {string} [search] 
     * @param {string} [game] 
     * @param {GetOverwolfEventTypesSort} [sort] 
     * @param {SortOrder} [order] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {number} [numberOfAvailableOffsets] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverwolfApiInterface
     */
    getOverwolfEventTypesRaw(requestParameters: GetOverwolfEventTypesRequest): Promise<runtime.ApiResponse<GetOverwolfEventTypesResponse>>;

    /**
     * Get list of all event types
     */
    getOverwolfEventTypes(requestParameters: GetOverwolfEventTypesRequest): Promise<GetOverwolfEventTypesResponse>;

    /**
     * Retrieves Overwolf game data.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverwolfApiInterface
     */
    getOverwolfGameRaw(requestParameters: GetOverwolfGameRequest): Promise<runtime.ApiResponse<OWGame>>;

    /**
     * Retrieves Overwolf game data.
     */
    getOverwolfGame(requestParameters: GetOverwolfGameRequest): Promise<OWGame>;

    /**
     * Retrieves Overwolf rewards for a specific game.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverwolfApiInterface
     */
    getOverwolfGameRewardsRaw(requestParameters: GetOverwolfGameRewardsRequest): Promise<runtime.ApiResponse<Array<OWReward>>>;

    /**
     * Retrieves Overwolf rewards for a specific game.
     */
    getOverwolfGameRewards(requestParameters: GetOverwolfGameRewardsRequest): Promise<Array<OWReward>>;

    /**
     * Get list of all games
     * @param {string} [search] 
     * @param {'all' | 'enabled' | 'disabled'} [seoFilter] 
     * @param {'all' | 'events' | 'time'} [eventFilter] 
     * @param {'all' | 'has' | 'none'} [steamFilter] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {number} [numberOfAvailableOffsets] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverwolfApiInterface
     */
    getOverwolfGamesRaw(requestParameters: GetOverwolfGamesRequest): Promise<runtime.ApiResponse<GetOverwolfGamesResponse>>;

    /**
     * Get list of all games
     */
    getOverwolfGames(requestParameters: GetOverwolfGamesRequest): Promise<GetOverwolfGamesResponse>;

    /**
     * Get list of all event types
     * @param {string} [game] ID of the game to filter quests by
     * @param {string} [isActive] Filter by active or inactive quests
     * @param {string} [search] 
     * @param {GetOverwolfQuestsSort} [sort] 
     * @param {SortOrder} [order] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {number} [numberOfAvailableOffsets] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverwolfApiInterface
     */
    getOverwolfQuestsRaw(requestParameters: GetOverwolfQuestsRequest): Promise<runtime.ApiResponse<GetOverwolfQuestsResponse>>;

    /**
     * Get list of all event types
     */
    getOverwolfQuests(requestParameters: GetOverwolfQuestsRequest): Promise<GetOverwolfQuestsResponse>;

    /**
     * Retrieves Overwolf user stats.
     * @param {string} [gameId] Optional Overwolf game ID to filter user stats.
     * @param {string} [rewardId] Optional reward ID to filter user stats.
     * @param {'EVENT' | 'TIME'} [rewardCategory] Optional reward category (\&quot;EVENT\&quot; or \&quot;TIME\&quot;) to filter user stats.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverwolfApiInterface
     */
    getOverwolfUserStatsRaw(requestParameters: GetOverwolfUserStatsRequest): Promise<runtime.ApiResponse<GetUserStatsResponse>>;

    /**
     * Retrieves Overwolf user stats.
     */
    getOverwolfUserStats(requestParameters: GetOverwolfUserStatsRequest): Promise<GetUserStatsResponse>;

    /**
     * Gets the total xp, time and played games of the current user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverwolfApiInterface
     */
    getOverwolfUserSummaryRaw(): Promise<runtime.ApiResponse<GetUserSummaryResponse>>;

    /**
     * Gets the total xp, time and played games of the current user.
     */
    getOverwolfUserSummary(): Promise<GetUserSummaryResponse>;

    /**
     * Retrieves Overwolf-related account experience transactions for a user.
     * @param {'OVERWOLF_TIME_REWARD' | 'OVERWOLF_EVENT_REWARD' | 'OVERWOLF_TIME_QUEST_REWARD'} subject The subject of the transaction. Must be one of the specified enum values.
     * @param {string} [overwolfRewardId] Optional Overwolf reward ID to filter transactions.
     * @param {string} [gameId] Optional game ID to filter transactions for a specific game.
     * @param {string} [notes] Optional notes to filter transactions.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverwolfApiInterface
     */
    getOverwolfXpRaw(requestParameters: GetOverwolfXpRequest): Promise<runtime.ApiResponse<GetOverwolfXPResponse>>;

    /**
     * Retrieves Overwolf-related account experience transactions for a user.
     */
    getOverwolfXp(requestParameters: GetOverwolfXpRequest): Promise<GetOverwolfXPResponse>;

    /**
     * Creates a new Overwolf user event log.
     * @param {CreateOWUserEventBody} [createOWUserEventBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverwolfApiInterface
     */
    logOWUserEventRaw(requestParameters: LogOWUserEventRequest): Promise<runtime.ApiResponse<void>>;

    /**
     * Creates a new Overwolf user event log.
     */
    logOWUserEvent(requestParameters: LogOWUserEventRequest): Promise<void>;

    /**
     * Remove a specific Overwolf event type and update the game doc if necessary
     * @param {string} id ID of the event type to remove
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverwolfApiInterface
     */
    removeOverwolfEventTypeRaw(requestParameters: RemoveOverwolfEventTypeRequest): Promise<runtime.ApiResponse<void>>;

    /**
     * Remove a specific Overwolf event type and update the game doc if necessary
     */
    removeOverwolfEventType(requestParameters: RemoveOverwolfEventTypeRequest): Promise<void>;

    /**
     * Remove a specific Overwolf quest, with all corresponding userStats
     * @param {string} id ID of the quest to remove
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverwolfApiInterface
     */
    removeOverwolfQuestRaw(requestParameters: RemoveOverwolfQuestRequest): Promise<runtime.ApiResponse<void>>;

    /**
     * Remove a specific Overwolf quest, with all corresponding userStats
     */
    removeOverwolfQuest(requestParameters: RemoveOverwolfQuestRequest): Promise<void>;

    /**
     * Search for games with enhanced features and SEO pages
     * @param {string} [search] Search term for game name
     * @param {boolean} [seoEnabled] Filter by SEO enabled games
     * @param {boolean} [timeTrackedGame] Filter by time tracking support
     * @param {boolean} [hasEvents] Filter by event support
     * @param {number} [limit] Number of results to return
     * @param {number} [offset] Offset for pagination
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverwolfApiInterface
     */
    searchEnhancedGamesRaw(requestParameters: SearchEnhancedGamesRequest): Promise<runtime.ApiResponse<InlineResponse20022>>;

    /**
     * Search for games with enhanced features and SEO pages
     */
    searchEnhancedGames(requestParameters: SearchEnhancedGamesRequest): Promise<InlineResponse20022>;

    /**
     * Import or update enhanced game data from Steam. Creates new game if doesn\'t exist.
     * @param {InlineObject14} inlineObject14 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverwolfApiInterface
     */
    updateEnhancedGameInfoRaw(requestParameters: UpdateEnhancedGameInfoRequest): Promise<runtime.ApiResponse<OWGameResponse>>;

    /**
     * Import or update enhanced game data from Steam. Creates new game if doesn\'t exist.
     */
    updateEnhancedGameInfo(requestParameters: UpdateEnhancedGameInfoRequest): Promise<OWGameResponse>;

    /**
     * Used to update existing Overwolf event type
     * @param {string} id 
     * @param {OWEventTypeBody} [oWEventTypeBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverwolfApiInterface
     */
    updateOverwolfEventTypeRaw(requestParameters: UpdateOverwolfEventTypeRequest): Promise<runtime.ApiResponse<OWEventTypeResponse>>;

    /**
     * Used to update existing Overwolf event type
     */
    updateOverwolfEventType(requestParameters: UpdateOverwolfEventTypeRequest): Promise<OWEventTypeResponse>;

    /**
     * Used to update existing Overwolf game
     * @param {string} id 
     * @param {CreateOverwolfGameBody} [createOverwolfGameBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverwolfApiInterface
     */
    updateOverwolfGameRaw(requestParameters: UpdateOverwolfGameRequest): Promise<runtime.ApiResponse<void>>;

    /**
     * Used to update existing Overwolf game
     */
    updateOverwolfGame(requestParameters: UpdateOverwolfGameRequest): Promise<void>;

    /**
     * Used to update existing Overwolf game images
     * @param {string} id 
     * @param {CreateOverwolfGameImages} [createOverwolfGameImages] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverwolfApiInterface
     */
    updateOverwolfGameImagesRaw(requestParameters: UpdateOverwolfGameImagesRequest): Promise<runtime.ApiResponse<void>>;

    /**
     * Used to update existing Overwolf game images
     */
    updateOverwolfGameImages(requestParameters: UpdateOverwolfGameImagesRequest): Promise<void>;

    /**
     * Used to update existing Overwolf quest (OWReward doc)
     * @param {string} id 
     * @param {OWQuestBody} [oWQuestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverwolfApiInterface
     */
    updateOverwolfQuestRaw(requestParameters: UpdateOverwolfQuestRequest): Promise<runtime.ApiResponse<OWQuestResponse>>;

    /**
     * Used to update existing Overwolf quest (OWReward doc)
     */
    updateOverwolfQuest(requestParameters: UpdateOverwolfQuestRequest): Promise<OWQuestResponse>;

}

/**
 * no description
 */
export class OverwolfApi extends runtime.BaseAPI implements OverwolfApiInterface {

    /**
     * Claims an Overwolf completed reward.
     */
    async claimOverwolfRewardRaw(requestParameters: ClaimOverwolfRewardRequest): Promise<runtime.ApiResponse<ClaimOverwolfRewardResponse>> {
        if (requestParameters.rewardId === null || requestParameters.rewardId === undefined) {
            throw new runtime.RequiredError('rewardId','Required parameter requestParameters.rewardId was null or undefined when calling claimOverwolfReward.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.rewardId !== undefined) {
            queryParameters['rewardId'] = requestParameters.rewardId;
        }

        if (requestParameters.rewardConfigId !== undefined) {
            queryParameters['rewardConfigId'] = requestParameters.rewardConfigId;
        }

        if (requestParameters.gameId !== undefined) {
            queryParameters['gameId'] = requestParameters.gameId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("User", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/overwolf/claim-reward`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimOverwolfRewardResponseFromJSON(jsonValue));
    }

    /**
     * Claims an Overwolf completed reward.
     */
    async claimOverwolfReward(requestParameters: ClaimOverwolfRewardRequest): Promise<ClaimOverwolfRewardResponse> {
        const response = await this.claimOverwolfRewardRaw(requestParameters);
        return await response.value();
    }

    /**
     * Used to create new Overwolf event type
     */
    async createOverwolfEventTypeRaw(requestParameters: CreateOverwolfEventTypeRequest): Promise<runtime.ApiResponse<OWEventTypeResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("Admin", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/overwolf/event-type`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OWEventTypeBodyToJSON(requestParameters.oWEventTypeBody),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => OWEventTypeResponseFromJSON(jsonValue));
    }

    /**
     * Used to create new Overwolf event type
     */
    async createOverwolfEventType(requestParameters: CreateOverwolfEventTypeRequest): Promise<OWEventTypeResponse> {
        const response = await this.createOverwolfEventTypeRaw(requestParameters);
        return await response.value();
    }

    /**
     * Used to create new Overwolf game
     */
    async createOverwolfGameRaw(requestParameters: CreateOverwolfGameRequest): Promise<runtime.ApiResponse<OWGame>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("Admin", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/overwolf/games`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateOverwolfGameBodyToJSON(requestParameters.createOverwolfGameBody),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => OWGameFromJSON(jsonValue));
    }

    /**
     * Used to create new Overwolf game
     */
    async createOverwolfGame(requestParameters: CreateOverwolfGameRequest): Promise<OWGame> {
        const response = await this.createOverwolfGameRaw(requestParameters);
        return await response.value();
    }

    /**
     * Used to create new Overwolf quest (OWReward doc)
     */
    async createOverwolfQuestRaw(requestParameters: CreateOverwolfQuestRequest): Promise<runtime.ApiResponse<OWQuestResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("Admin", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/overwolf/quest`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OWQuestBodyToJSON(requestParameters.oWQuestBody),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => OWQuestResponseFromJSON(jsonValue));
    }

    /**
     * Used to create new Overwolf quest (OWReward doc)
     */
    async createOverwolfQuest(requestParameters: CreateOverwolfQuestRequest): Promise<OWQuestResponse> {
        const response = await this.createOverwolfQuestRaw(requestParameters);
        return await response.value();
    }

    /**
     * Dismiss the weekly limit feedback for the user\'s Overwolf reward stats.
     */
    async dismissWeeklyLimitFeedbackRaw(): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("User", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/overwolf/weekly-limit-feedback`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Dismiss the weekly limit feedback for the user\'s Overwolf reward stats.
     */
    async dismissWeeklyLimitFeedback(): Promise<void> {
        await this.dismissWeeklyLimitFeedbackRaw();
    }

    /**
     * Get list of all event types without pagination
     */
    async getAllOverwolfEventTypesRaw(): Promise<runtime.ApiResponse<InlineResponse20021>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("Admin", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/overwolf/event-types/all`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => InlineResponse20021FromJSON(jsonValue));
    }

    /**
     * Get list of all event types without pagination
     */
    async getAllOverwolfEventTypes(): Promise<InlineResponse20021> {
        const response = await this.getAllOverwolfEventTypesRaw();
        return await response.value();
    }

    /**
     * Get enhanced game information including all original and Steam fields for Admin and front-end display
     */
    async getEnhancedGameInfoRaw(requestParameters: GetEnhancedGameInfoRequest): Promise<runtime.ApiResponse<InlineResponse20020>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getEnhancedGameInfo.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/overwolf/enhanced-game-info/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => InlineResponse20020FromJSON(jsonValue));
    }

    /**
     * Get enhanced game information including all original and Steam fields for Admin and front-end display
     */
    async getEnhancedGameInfo(requestParameters: GetEnhancedGameInfoRequest): Promise<InlineResponse20020> {
        const response = await this.getEnhancedGameInfoRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get game information by URL slug for public game pages
     */
    async getGameBySlugRaw(requestParameters: GetGameBySlugRequest): Promise<runtime.ApiResponse<OWGameResponse>> {
        if (requestParameters.slug === null || requestParameters.slug === undefined) {
            throw new runtime.RequiredError('slug','Required parameter requestParameters.slug was null or undefined when calling getGameBySlug.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/overwolf/games/by-slug/{slug}`.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters.slug))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => OWGameResponseFromJSON(jsonValue));
    }

    /**
     * Get game information by URL slug for public game pages
     */
    async getGameBySlug(requestParameters: GetGameBySlugRequest): Promise<OWGameResponse> {
        const response = await this.getGameBySlugRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get list of all event dumps
     */
    async getGameEventDataRaw(requestParameters: GetGameEventDataRequest): Promise<runtime.ApiResponse<GetGameEventDataResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.gameId !== undefined) {
            queryParameters['gameId'] = requestParameters.gameId;
        }

        if (requestParameters.userId !== undefined) {
            queryParameters['userId'] = requestParameters.userId;
        }

        if (requestParameters.eventName !== undefined) {
            queryParameters['eventName'] = requestParameters.eventName;
        }

        if (requestParameters.fieldName !== undefined) {
            queryParameters['fieldName'] = requestParameters.fieldName;
        }

        if (requestParameters.fieldValue !== undefined) {
            queryParameters['fieldValue'] = requestParameters.fieldValue;
        }

        if (requestParameters.regex !== undefined) {
            queryParameters['regex'] = requestParameters.regex;
        }

        if (requestParameters.dateStart !== undefined) {
            queryParameters['dateStart'] = requestParameters.dateStart;
        }

        if (requestParameters.dateEnd !== undefined) {
            queryParameters['dateEnd'] = requestParameters.dateEnd;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.numberOfAvailableOffsets !== undefined) {
            queryParameters['numberOfAvailableOffsets'] = requestParameters.numberOfAvailableOffsets;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("Admin", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/game-event-data`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => GetGameEventDataResponseFromJSON(jsonValue));
    }

    /**
     * Get list of all event dumps
     */
    async getGameEventData(requestParameters: GetGameEventDataRequest): Promise<GetGameEventDataResponse> {
        const response = await this.getGameEventDataRaw(requestParameters);
        return await response.value();
    }

    /**
     * Fetch available event types for a specific game
     */
    async getOverwolfAvailableEventTypesRaw(requestParameters: GetOverwolfAvailableEventTypesRequest): Promise<runtime.ApiResponse<Array<OWEventTypeResponse>>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getOverwolfAvailableEventTypes.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("Admin", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/overwolf/available-event-types/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OWEventTypeResponseFromJSON));
    }

    /**
     * Fetch available event types for a specific game
     */
    async getOverwolfAvailableEventTypes(requestParameters: GetOverwolfAvailableEventTypesRequest): Promise<Array<OWEventTypeResponse>> {
        const response = await this.getOverwolfAvailableEventTypesRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get list of all dual games
     */
    async getOverwolfDualGamesRaw(): Promise<runtime.ApiResponse<Array<OWGame>>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("Optional", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/overwolf/dual-games`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OWGameFromJSON));
    }

    /**
     * Get list of all dual games
     */
    async getOverwolfDualGames(): Promise<Array<OWGame>> {
        const response = await this.getOverwolfDualGamesRaw();
        return await response.value();
    }

    /**
     * Get list of all game event mappings
     */
    async getOverwolfEventMappingsRaw(): Promise<runtime.ApiResponse<GetOverwolfEventMappingsResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("Admin", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/overwolf/event-mappings`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => GetOverwolfEventMappingsResponseFromJSON(jsonValue));
    }

    /**
     * Get list of all game event mappings
     */
    async getOverwolfEventMappings(): Promise<GetOverwolfEventMappingsResponse> {
        const response = await this.getOverwolfEventMappingsRaw();
        return await response.value();
    }

    /**
     * Get a single event type by ID
     */
    async getOverwolfEventTypeRaw(requestParameters: GetOverwolfEventTypeRequest): Promise<runtime.ApiResponse<OWEventType>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getOverwolfEventType.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("Admin", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/overwolf/event-type/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => OWEventTypeFromJSON(jsonValue));
    }

    /**
     * Get a single event type by ID
     */
    async getOverwolfEventType(requestParameters: GetOverwolfEventTypeRequest): Promise<OWEventType> {
        const response = await this.getOverwolfEventTypeRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get list of all event types
     */
    async getOverwolfEventTypesRaw(requestParameters: GetOverwolfEventTypesRequest): Promise<runtime.ApiResponse<GetOverwolfEventTypesResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.game !== undefined) {
            queryParameters['game'] = requestParameters.game;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.numberOfAvailableOffsets !== undefined) {
            queryParameters['numberOfAvailableOffsets'] = requestParameters.numberOfAvailableOffsets;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("Admin", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/overwolf/event-types`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => GetOverwolfEventTypesResponseFromJSON(jsonValue));
    }

    /**
     * Get list of all event types
     */
    async getOverwolfEventTypes(requestParameters: GetOverwolfEventTypesRequest): Promise<GetOverwolfEventTypesResponse> {
        const response = await this.getOverwolfEventTypesRaw(requestParameters);
        return await response.value();
    }

    /**
     * Retrieves Overwolf game data.
     */
    async getOverwolfGameRaw(requestParameters: GetOverwolfGameRequest): Promise<runtime.ApiResponse<OWGame>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getOverwolfGame.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/overwolf/games/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => OWGameFromJSON(jsonValue));
    }

    /**
     * Retrieves Overwolf game data.
     */
    async getOverwolfGame(requestParameters: GetOverwolfGameRequest): Promise<OWGame> {
        const response = await this.getOverwolfGameRaw(requestParameters);
        return await response.value();
    }

    /**
     * Retrieves Overwolf rewards for a specific game.
     */
    async getOverwolfGameRewardsRaw(requestParameters: GetOverwolfGameRewardsRequest): Promise<runtime.ApiResponse<Array<OWReward>>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getOverwolfGameRewards.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/overwolf/games/{id}/rewards`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OWRewardFromJSON));
    }

    /**
     * Retrieves Overwolf rewards for a specific game.
     */
    async getOverwolfGameRewards(requestParameters: GetOverwolfGameRewardsRequest): Promise<Array<OWReward>> {
        const response = await this.getOverwolfGameRewardsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get list of all games
     */
    async getOverwolfGamesRaw(requestParameters: GetOverwolfGamesRequest): Promise<runtime.ApiResponse<GetOverwolfGamesResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.seoFilter !== undefined) {
            queryParameters['seoFilter'] = requestParameters.seoFilter;
        }

        if (requestParameters.eventFilter !== undefined) {
            queryParameters['eventFilter'] = requestParameters.eventFilter;
        }

        if (requestParameters.steamFilter !== undefined) {
            queryParameters['steamFilter'] = requestParameters.steamFilter;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.numberOfAvailableOffsets !== undefined) {
            queryParameters['numberOfAvailableOffsets'] = requestParameters.numberOfAvailableOffsets;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("Admin", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/overwolf/games`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => GetOverwolfGamesResponseFromJSON(jsonValue));
    }

    /**
     * Get list of all games
     */
    async getOverwolfGames(requestParameters: GetOverwolfGamesRequest): Promise<GetOverwolfGamesResponse> {
        const response = await this.getOverwolfGamesRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get list of all event types
     */
    async getOverwolfQuestsRaw(requestParameters: GetOverwolfQuestsRequest): Promise<runtime.ApiResponse<GetOverwolfQuestsResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.game !== undefined) {
            queryParameters['game'] = requestParameters.game;
        }

        if (requestParameters.isActive !== undefined) {
            queryParameters['isActive'] = requestParameters.isActive;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.numberOfAvailableOffsets !== undefined) {
            queryParameters['numberOfAvailableOffsets'] = requestParameters.numberOfAvailableOffsets;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("Admin", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/overwolf/quests`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => GetOverwolfQuestsResponseFromJSON(jsonValue));
    }

    /**
     * Get list of all event types
     */
    async getOverwolfQuests(requestParameters: GetOverwolfQuestsRequest): Promise<GetOverwolfQuestsResponse> {
        const response = await this.getOverwolfQuestsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Retrieves Overwolf user stats.
     */
    async getOverwolfUserStatsRaw(requestParameters: GetOverwolfUserStatsRequest): Promise<runtime.ApiResponse<GetUserStatsResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.gameId !== undefined) {
            queryParameters['gameId'] = requestParameters.gameId;
        }

        if (requestParameters.rewardId !== undefined) {
            queryParameters['rewardId'] = requestParameters.rewardId;
        }

        if (requestParameters.rewardCategory !== undefined) {
            queryParameters['rewardCategory'] = requestParameters.rewardCategory;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("User", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/overwolf/user-stats`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => GetUserStatsResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves Overwolf user stats.
     */
    async getOverwolfUserStats(requestParameters: GetOverwolfUserStatsRequest): Promise<GetUserStatsResponse> {
        const response = await this.getOverwolfUserStatsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets the total xp, time and played games of the current user.
     */
    async getOverwolfUserSummaryRaw(): Promise<runtime.ApiResponse<GetUserSummaryResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("User", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/overwolf/user-summary`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => GetUserSummaryResponseFromJSON(jsonValue));
    }

    /**
     * Gets the total xp, time and played games of the current user.
     */
    async getOverwolfUserSummary(): Promise<GetUserSummaryResponse> {
        const response = await this.getOverwolfUserSummaryRaw();
        return await response.value();
    }

    /**
     * Retrieves Overwolf-related account experience transactions for a user.
     */
    async getOverwolfXpRaw(requestParameters: GetOverwolfXpRequest): Promise<runtime.ApiResponse<GetOverwolfXPResponse>> {
        if (requestParameters.subject === null || requestParameters.subject === undefined) {
            throw new runtime.RequiredError('subject','Required parameter requestParameters.subject was null or undefined when calling getOverwolfXp.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.overwolfRewardId !== undefined) {
            queryParameters['overwolfRewardId'] = requestParameters.overwolfRewardId;
        }

        if (requestParameters.gameId !== undefined) {
            queryParameters['gameId'] = requestParameters.gameId;
        }

        if (requestParameters.subject !== undefined) {
            queryParameters['subject'] = requestParameters.subject;
        }

        if (requestParameters.notes !== undefined) {
            queryParameters['notes'] = requestParameters.notes;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("User", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/overwolf/xp`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => GetOverwolfXPResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves Overwolf-related account experience transactions for a user.
     */
    async getOverwolfXp(requestParameters: GetOverwolfXpRequest): Promise<GetOverwolfXPResponse> {
        const response = await this.getOverwolfXpRaw(requestParameters);
        return await response.value();
    }

    /**
     * Creates a new Overwolf user event log.
     */
    async logOWUserEventRaw(requestParameters: LogOWUserEventRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("User", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/overwolf/user-events`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateOWUserEventBodyToJSON(requestParameters.createOWUserEventBody),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Creates a new Overwolf user event log.
     */
    async logOWUserEvent(requestParameters: LogOWUserEventRequest): Promise<void> {
        await this.logOWUserEventRaw(requestParameters);
    }

    /**
     * Remove a specific Overwolf event type and update the game doc if necessary
     */
    async removeOverwolfEventTypeRaw(requestParameters: RemoveOverwolfEventTypeRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling removeOverwolfEventType.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("Admin", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/overwolf/event-type/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Remove a specific Overwolf event type and update the game doc if necessary
     */
    async removeOverwolfEventType(requestParameters: RemoveOverwolfEventTypeRequest): Promise<void> {
        await this.removeOverwolfEventTypeRaw(requestParameters);
    }

    /**
     * Remove a specific Overwolf quest, with all corresponding userStats
     */
    async removeOverwolfQuestRaw(requestParameters: RemoveOverwolfQuestRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling removeOverwolfQuest.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("Admin", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/overwolf/quest/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Remove a specific Overwolf quest, with all corresponding userStats
     */
    async removeOverwolfQuest(requestParameters: RemoveOverwolfQuestRequest): Promise<void> {
        await this.removeOverwolfQuestRaw(requestParameters);
    }

    /**
     * Search for games with enhanced features and SEO pages
     */
    async searchEnhancedGamesRaw(requestParameters: SearchEnhancedGamesRequest): Promise<runtime.ApiResponse<InlineResponse20022>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.seoEnabled !== undefined) {
            queryParameters['seoEnabled'] = requestParameters.seoEnabled;
        }

        if (requestParameters.timeTrackedGame !== undefined) {
            queryParameters['timeTrackedGame'] = requestParameters.timeTrackedGame;
        }

        if (requestParameters.hasEvents !== undefined) {
            queryParameters['hasEvents'] = requestParameters.hasEvents;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/overwolf/enhanced-games/search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => InlineResponse20022FromJSON(jsonValue));
    }

    /**
     * Search for games with enhanced features and SEO pages
     */
    async searchEnhancedGames(requestParameters: SearchEnhancedGamesRequest): Promise<InlineResponse20022> {
        const response = await this.searchEnhancedGamesRaw(requestParameters);
        return await response.value();
    }

    /**
     * Import or update enhanced game data from Steam. Creates new game if doesn\'t exist.
     */
    async updateEnhancedGameInfoRaw(requestParameters: UpdateEnhancedGameInfoRequest): Promise<runtime.ApiResponse<OWGameResponse>> {
        if (requestParameters.inlineObject14 === null || requestParameters.inlineObject14 === undefined) {
            throw new runtime.RequiredError('inlineObject14','Required parameter requestParameters.inlineObject14 was null or undefined when calling updateEnhancedGameInfo.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("Admin", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/overwolf/enhanced-game-info`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InlineObject14ToJSON(requestParameters.inlineObject14),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => OWGameResponseFromJSON(jsonValue));
    }

    /**
     * Import or update enhanced game data from Steam. Creates new game if doesn\'t exist.
     */
    async updateEnhancedGameInfo(requestParameters: UpdateEnhancedGameInfoRequest): Promise<OWGameResponse> {
        const response = await this.updateEnhancedGameInfoRaw(requestParameters);
        return await response.value();
    }

    /**
     * Used to update existing Overwolf event type
     */
    async updateOverwolfEventTypeRaw(requestParameters: UpdateOverwolfEventTypeRequest): Promise<runtime.ApiResponse<OWEventTypeResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateOverwolfEventType.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("Admin", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/overwolf/event-type/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: OWEventTypeBodyToJSON(requestParameters.oWEventTypeBody),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => OWEventTypeResponseFromJSON(jsonValue));
    }

    /**
     * Used to update existing Overwolf event type
     */
    async updateOverwolfEventType(requestParameters: UpdateOverwolfEventTypeRequest): Promise<OWEventTypeResponse> {
        const response = await this.updateOverwolfEventTypeRaw(requestParameters);
        return await response.value();
    }

    /**
     * Used to update existing Overwolf game
     */
    async updateOverwolfGameRaw(requestParameters: UpdateOverwolfGameRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateOverwolfGame.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("Admin", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/overwolf/games/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateOverwolfGameBodyToJSON(requestParameters.createOverwolfGameBody),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used to update existing Overwolf game
     */
    async updateOverwolfGame(requestParameters: UpdateOverwolfGameRequest): Promise<void> {
        await this.updateOverwolfGameRaw(requestParameters);
    }

    /**
     * Used to update existing Overwolf game images
     */
    async updateOverwolfGameImagesRaw(requestParameters: UpdateOverwolfGameImagesRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateOverwolfGameImages.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("Admin", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/overwolf/games/{id}/images`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateOverwolfGameImagesToJSON(requestParameters.createOverwolfGameImages),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used to update existing Overwolf game images
     */
    async updateOverwolfGameImages(requestParameters: UpdateOverwolfGameImagesRequest): Promise<void> {
        await this.updateOverwolfGameImagesRaw(requestParameters);
    }

    /**
     * Used to update existing Overwolf quest (OWReward doc)
     */
    async updateOverwolfQuestRaw(requestParameters: UpdateOverwolfQuestRequest): Promise<runtime.ApiResponse<OWQuestResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateOverwolfQuest.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("Admin", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/overwolf/quest/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: OWQuestBodyToJSON(requestParameters.oWQuestBody),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => OWQuestResponseFromJSON(jsonValue));
    }

    /**
     * Used to update existing Overwolf quest (OWReward doc)
     */
    async updateOverwolfQuest(requestParameters: UpdateOverwolfQuestRequest): Promise<OWQuestResponse> {
        const response = await this.updateOverwolfQuestRaw(requestParameters);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum GetOverwolfGamesSeoFilterEnum {
    All = 'all',
    Enabled = 'enabled',
    Disabled = 'disabled'
}
/**
    * @export
    * @enum {string}
    */
export enum GetOverwolfGamesEventFilterEnum {
    All = 'all',
    Events = 'events',
    Time = 'time'
}
/**
    * @export
    * @enum {string}
    */
export enum GetOverwolfGamesSteamFilterEnum {
    All = 'all',
    Has = 'has',
    None = 'none'
}
/**
    * @export
    * @enum {string}
    */
export enum GetOverwolfUserStatsRewardCategoryEnum {
    EVENT = 'EVENT',
    TIME = 'TIME'
}
/**
    * @export
    * @enum {string}
    */
export enum GetOverwolfXpSubjectEnum {
    TIMEREWARD = 'OVERWOLF_TIME_REWARD',
    EVENTREWARD = 'OVERWOLF_EVENT_REWARD',
    TIMEQUESTREWARD = 'OVERWOLF_TIME_QUEST_REWARD'
}
